import React, { useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { Collapse, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import Link from 'components/Link';
import NavList from '../NavList';
import useStyles from './style';
import { INavItemProps } from './types';

function NavItem({
  activePath,
  className,
  label,
  name,
  path,
  options,
  onPathChange,
}: INavItemProps) {
  const match = useRouteMatch();
  const isActive = activePath === path;
  const classes = useStyles({ active: isActive });

  const handleExpandToggle = useCallback(() => {
    onPathChange(isActive ? null : path);
  }, [isActive, path, onPathChange]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => match && onPathChange(path), []);

  return (
    <li className={classnames(classes.root, className)} data-testid={`${name}-item`}>
      {options ? (
        <React.Fragment>
          <button
            className={classnames(classes.labelContainer, classes.expandHeader)}
            data-testid="expand-button"
            onClick={handleExpandToggle}
          >
            <Typography className={classes.label}>{label}</Typography>
            <ExpandMore
              className={classnames({ [classes.rotate180]: isActive })}
              data-testid="expand-icon"
            />
          </button>
          <Collapse data-testid="expandable-content" in={isActive} timeout="auto" unmountOnExit>
            <NavList basePath={path} className={classes.subList} items={options} />
          </Collapse>
        </React.Fragment>
      ) : (
        <Link
          className={classnames(classes.labelContainer, classes.link)}
          color="inherit"
          component={NavLink}
          data-testid="link"
          key={path}
          to={path}
          onClick={handleExpandToggle}
        >
          <Typography className={classes.label} data-testid="link-label">
            {label}
          </Typography>
        </Link>
      )}
    </li>
  );
}

export default React.memo(NavItem);
